import React, { useState, createContext, useEffect } from "react";
import { Box } from "@mui/material";

import { checkCloseDate } from "../../api/apiManagement";
import FormPage from "./FormPage";
import ConfirmPage from "./ConfirmPage";
import ThankYouPage from "./ThankYouPage";
import EndPage from "./EndPage";

export const FormContext = createContext();

const Form = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [imeiChance, setImeiChange] = useState(0);
  const dataValue = {
    currentStep,
    setCurrentStep,
    data,
    setData,
    isLoading,
    setIsLoading,
    imeiChance,
    setImeiChange,
  };
  useEffect(() => {
    checkCloseDate({ code: `S25Live2025` })
      .then((res) => {
        const currentStatus = res.data.status;

        if (currentStatus == "200") {
        }

        if (currentStatus == "502") {
          setCurrentStep(3);
        }
        console.log(res);
      })
      .catch((err) => console.log(err));
  }, []);


  return (
    <FormContext.Provider value={dataValue}>
      <Box sx={{ margin: "20px" }}>
        {currentStep === 0 ? (
          <FormPage />
        ) : currentStep === 1 ? (
          <ConfirmPage />
        ) : currentStep === 2 ? (
          <ThankYouPage />
        ) : currentStep === 3 ? (
          <EndPage />
        ) : (
          <></>
        )}
      </Box>
    </FormContext.Provider>
  );
};

export default Form;
